import React, { Component, ReactNode } from "react";
import logger from "../utils/logger";

interface Props {
  children: ReactNode;
  context?: string;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Route through the logger so the error both consoles and ships to the
    // backend client-log ingest (ADR-009) — not a bare console.error. The React
    // component stack lives in errorInfo; keep it out of the shipped payload to
    // avoid leaking PHI from rendered props (CLAUDE.md → Compliance). The
    // context label (no PHI) is forwarded as a non-shipped extra arg.
    logger.error(
      `ErrorBoundary caught error${this.props.context ? ` in ${this.props.context}` : ""}`,
      error,
      { componentStack: errorInfo.componentStack },
    );
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error</h1>;
    }

    return this.props.children;
  }
}
